import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-178568b8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "rc-page"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-title"
}, "鲸豆充值", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-placeholder"
}, null, -1));
const _hoisted_4 = {
  class: "rc-balance"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bal-label"
}, "当前鲸豆余额", -1));
const _hoisted_6 = {
  class: "bal-num"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "rc-section-title"
}, [/*#__PURE__*/_createTextVNode(" 选择充值金额 "), /*#__PURE__*/_createElementVNode("span", {
  class: "limit-tip"
}, "单笔最高 50 元")], -1));
const _hoisted_8 = {
  class: "amount-grid"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "amt-val"
};
const _hoisted_11 = {
  class: "amt-beans"
};
const _hoisted_12 = {
  class: "custom-row"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "custom-label"
}, "自定义金额", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "rc-section-title"
}, "支付方式", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "channel-row"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "channel-item active"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "ch-icon"
}, "💙"), /*#__PURE__*/_createTextVNode("支付宝支付 ")])], -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "rc-notice"
}, [/*#__PURE__*/_createElementVNode("p", null, "1 元 = 1 鲸豆 · 单笔最高 50 元 · 充值即时到账"), /*#__PURE__*/_createElementVNode("p", null, "鲸豆可用于开通会员时长，充值成功后不可退款"), /*#__PURE__*/_createElementVNode("p", null, "需要单笔大额充值可联系客服")], -1));
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { showNotify } from '@nutui/nutui';
import service from '@/utils/request';
import request from '@/utils/request';
export default {
  __name: 'RechargeView',
  setup(__props) {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    // 当前鲸豆余额
    const balance = computed(() => store.state.user?.beans ?? 0);
    // 快捷金额档位（单笔充值最高 50 元）
    const amounts = [6, 10, 20, 30, 50];
    const selectedAmount = ref(30);
    const customAmount = ref('');
    const channel = ref('alipay');
    const loading = ref(false);

    // 最终充值金额：自定义优先，否则选中档位
    const finalBeans = computed(() => {
      if (customAmount.value && Number(customAmount.value) > 0) {
        return Number(customAmount.value);
      }
      return selectedAmount.value;
    });
    const selectAmount = amt => {
      selectedAmount.value = amt;
      customAmount.value = '';
    };
    const goBack = () => {
      router.back();
    };

    // 刷新余额
    const getInfo = () => {
      request.get('/getInfo').then(res => {
        if (res.code == 200) {
          store.dispatch('login', res);
        }
      });
    };
    const doRecharge = async () => {
      const beans = finalBeans.value;
      if (!beans || beans <= 0 || !Number.isInteger(beans)) {
        showNotify.warn('请输入正确的充值金额');
        return;
      }
      if (beans > 50) {
        showNotify.warn('单笔充值最高 50 元');
        return;
      }
      loading.value = true;
      try {
        const res = await service.post('/pay/create', {
          beans,
          channel: channel.value
        });
        if (res.code == 200) {
          localStorage.setItem('payOutTradeNo', res.data.outTradeNo);
          window.location.href = res.data.payUrl;
        } else {
          showNotify.warn(res.msg);
          loading.value = false;
        }
      } catch (e) {
        loading.value = false;
      }
    };

    // 支付结果轮询（每2秒，最多30次）
    const startPoll = outTradeNo => {
      let count = 0;
      const timer = setInterval(() => {
        count++;
        service.get('/pay/query', {
          params: {
            outTradeNo
          }
        }).then(res => {
          if (res.code == 200 && res.data.status == 1) {
            clearInterval(timer);
            localStorage.removeItem('payOutTradeNo');
            showNotify.success('充值成功');
            getInfo();
          } else if (count >= 30) {
            clearInterval(timer);
            showNotify.warn('支付结果确认超时，请稍后在"我的"页面查看');
          }
        });
      }, 2000);
    };
    onMounted(() => {
      const qNo = route.query.outTradeNo;
      const stored = localStorage.getItem('payOutTradeNo');
      if (qNo) {
        startPoll(qNo);
        router.replace({
          path: '/recharge'
        });
      } else if (stored) {
        startPoll(stored);
      }
    });
    return (_ctx, _cache) => {
      const _component_nut_input = _resolveComponent("nut-input");
      const _component_nut_button = _resolveComponent("nut-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "rc-navbar"
      }, [_createElementVNode("span", {
        class: "back-btn",
        onClick: goBack
      }, "← 返回"), _hoisted_2, _hoisted_3]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, _toDisplayString(balance.value), 1)]), _hoisted_7, _createElementVNode("div", _hoisted_8, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(amounts, amt => {
        return _createElementVNode("div", {
          class: _normalizeClass(["amount-item", {
            active: selectedAmount.value === amt
          }]),
          key: amt,
          onClick: $event => selectAmount(amt)
        }, [_createElementVNode("div", _hoisted_10, "¥" + _toDisplayString(amt), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(amt) + " 鲸豆", 1)], 10, _hoisted_9);
      }), 64))]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createVNode(_component_nut_input, {
        class: "custom-input",
        modelValue: customAmount.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => customAmount.value = $event),
        type: "number",
        placeholder: "输入金额（元），最高 50"
      }, null, 8, ["modelValue"])]), _hoisted_14, _hoisted_15, _createVNode(_component_nut_button, {
        class: "rc-submit",
        type: "primary",
        block: "true",
        loading: loading.value,
        onClick: doRecharge
      }, {
        default: _withCtx(() => [_createTextVNode("立即充值 ¥" + _toDisplayString(finalBeans.value), 1)]),
        _: 1
      }, 8, ["loading"]), _hoisted_16]);
    };
  }
};